var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349_5042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12.8984C24.5 6.27102 19.1274 0.898438 12.5 0.898438C5.87258 0.898438 0.5 6.27102 0.5 12.8984C0.5 18.8879 4.8882 23.8524 10.625 24.7527V16.3672H7.57812V12.8984H10.625V10.2547C10.625 7.24719 12.4166 5.58594 15.1576 5.58594C16.4701 5.58594 17.8438 5.82031 17.8438 5.82031V8.77344H16.3306C14.84 8.77344 14.375 9.69852 14.375 10.6484V12.8984H17.7031L17.1711 16.3672H14.375V24.7527C20.1118 23.8524 24.5 18.8879 24.5 12.8984Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1711 16.3672L17.7031 12.8984H14.375V10.6484C14.375 9.69945 14.84 8.77344 16.3306 8.77344H17.8438V5.82031C17.8438 5.82031 16.4705 5.58594 15.1576 5.58594C12.4166 5.58594 10.625 7.24719 10.625 10.2547V12.8984H7.57812V16.3672H10.625V24.7527C11.8674 24.947 13.1326 24.947 14.375 24.7527V16.3672H17.1711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349_5042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.898438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5dd84dc34636ac6bb98ea3beabe69499.svg";
export { ForwardRef as ReactComponent };